import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { ToastrService } from 'ngx-toastr';
import { EventsService } from '../../../../services/events.service';
import { ModalActionsService } from '../../../../services/modalActions.service';

@Component({
  selector: 'app-race-update-status',
  templateUrl: './race-update-status.component.html',
  styleUrls: ['./race-update-status.component.scss']
})
export class RaceUpdateStatusComponent implements OnInit {

  @Input() race;
  meta: {
    loading: boolean,
    saving: boolean
  };
  possibleStatuses: string[];
  selectedStatus: string;
  userId: number;

  constructor(
    private activeModal: NgbActiveModal,
    private notification: ToastrService,
    private eventsService: EventsService,
    private modalActionsService: ModalActionsService,
  ) { }

  ngOnInit() {
    this.meta = {
      loading: false,
      saving: false
    };

    this.possibleStatuses = [
      'No Enquiry',
      'Weighed in',
      'Under Review',
      'Objection',
      'Open Stewards Enquiry',
      'Stewards Enquiry - May Affect Placings',
      'Stewards Enquiry - Will Not Affect Placings',
      'Enquiry Complete - Placings Altered',
      'Enquiry Complete - Placings Unaltered',
    ];

    this.eventsService.observableUser.subscribe(data => {
      this.userId = data.id;
    });
  }

  confirm = () => {
    this.meta.saving = true;
    this.modalActionsService.updateRace(this.race, {status: this.selectedStatus, userId: this.userId}).subscribe(
      res => {
        this.activeModal.close(res);
        this.notification.success(`${this.race.raceName} status has been updated.`, 'Success!');
        this.meta.saving = false;
      },
      err => {
        this.notification.error(`Could't update the race: ` +
        `${this.eventsService.getApiErrorMessage(err)}`, 'Error!', { disableTimeOut: true });
        this.meta.saving = false;
      }
    );
  }

  cancel = (action) => {
    this.activeModal.dismiss(action);
  }

}
